<template>
  <div class="container-fluid px-0">
    <h1 class="page-title letraDelTitulo col-12">PARTIDOS JUDICIALES</h1>
    <div class="container-fluid">
      <div class="row d-flex px-lg-5">
          <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
            <svg class="viewbox" version="1.2" viewBox="-100 0 1400 1100">
              <g transform="translate(220.76186,6.6183848)">           
                <path v-for="municipio in municipios" v-bind:key="municipio.id" v-on:click="CargaLaInformacionDelMunicipioSeleccionado(municipio.partidoJudicialId)" :onmouseover="municipio.onmouseover" :onmouseout="municipio.onmouseout" :style="municipio.style" :d="municipio.d" :id="municipio.id" />
              </g>
            </svg>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 area-poder">
            <div v-if="!EstaVacioLosDatos()" class="area-texto">
              <h2 class="letraDelTitulo">{{informacionDelPartido.nombreDelPartido}}</h2>
              <br />
              <div>
                <h4 class="letraDelTitulo">{{informacionDelPartido.municipios.titulo}}</h4>
                <ul>
                  <li v-for="municipio in informacionDelPartido.municipios.informacion" v-bind:key="municipio">
                    <h6>{{municipio}}</h6>
                  </li>
                </ul>    
              </div>
              <div>
                <h4 class="letraDelTitulo">{{informacionDelPartido.juzgados.titulo}}</h4>
                <ul>
                  <li v-for="juzgado in informacionDelPartido.juzgados.informacion" v-bind:key="juzgado">
                    <h6>{{juzgado}}</h6>
                  </li>
                </ul>    
              </div>
            </div>
            <div v-else>
              <h2>Seleccione un municipio para ver la información del mismo.</h2>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import aguascalientes from '@/../static/js/sistemas/paginaoficial/aguascalientes.json'
  import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
 
  export default {
    data () {
      return {
        enumeraciones_sicpo,
        municipios: aguascalientes.path,
        informacionDelPartido: Object,
        nombreDeVariableDelComponente: "cargoPaginaOficial"
      }
    },
    mounted() {
      this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
    },
    methods: {
      EstaVacioLosDatos: function() {
        return Object.keys(this.informacionDelPartido).length === 0 ? true : false;
      },
      CargaLaInformacionDelMunicipioSeleccionado: function(partidoJudicialId) {
        switch (partidoJudicialId) {
          case 1:       
            this.informacionDelPartido = {
              nombreDelPartido: "PRIMER PARTIDO JUDICIAL",
              municipios: {
                titulo: "MUNICIPIOS QUE COMPRENDE:", 
                informacion: ["Aguascalientes (SEDE)", "El Llano"]
              }, 
              juzgados: {
                titulo: "JUZGADOS CON LOS QUE CUENTA:",
                informacion: ["6 Mercantiles", "3 Civiles", "6 Familiares", "1 Penal Tradicional", "1 Penal Acusatorio", "1 Ejecución de Penas y Medidas de Seguridad","2 Laborales"]
              }
            }
            break;
          case 2:
            this.informacionDelPartido = {
              nombreDelPartido: "SEGUNDO PARTIDO JUDICIAL",
              municipios: {
                titulo: "MUNICIPIOS QUE COMPRENDE:", 
                informacion: ["Calvillo (SEDE)"]
              }, 
              juzgados: {
                titulo: "JUZGADOS CON LOS QUE CUENTA:",
                informacion: ["1 Mixto de Primera Instancia", "1 Penal Acusatorio"]
              }
            }
            break;
          case 3:
            this.informacionDelPartido = {
              nombreDelPartido: "TERCER PARTIDO JUDICIAL",
              municipios: {
                titulo: "MUNICIPIOS QUE COMPRENDE:", 
                informacion: ["Pabellón de Arteaga (SEDE)", "Asientos", "San Francisco de los Romo", "San José de Gracia"]
              }, 
              juzgados: {
                titulo: "JUZGADOS CON LOS QUE CUENTA:",
                informacion: ["1 Mixto de Primera Instancia", "1 Penal Acusatorio"]
              }
            }
            break;
          case 4:
            this.informacionDelPartido = {
              nombreDelPartido: "CUARTO PARTIDO JUDICIAL",
              municipios: {
                titulo: "MUNICIPIOS QUE COMPRENDE:", 
                informacion: ["Rincón de Romos (SEDE)", "Cosio", "Tepezala"]
              }, 
              juzgados: {
                titulo: "JUZGADOS CON LOS QUE CUENTA:",
                informacion: ["1 Mixto de Primera Instancia", "1 Penal Acusatorio"]
              }
            }
            break;
          case 5:
            this.informacionDelPartido = {
              nombreDelPartido: "QUINTO PARTIDO JUDICIAL",
              municipios: {
                titulo: "MUNICIPIOS QUE COMPRENDE:", 
                informacion: ["Jesús María (SEDE)"]
              }, 
              juzgados: {
                titulo: "JUZGADOS CON LOS QUE CUENTA:",
                informacion: ["1 Mixto de Primera Instancia", "1 Penal Acusatorio", "1 Preparación para Adolescentes", "1 Especializado para Adolescentes", "1 Penal Acusatorio para Adolescentes"]
              }
            }
            break;
        }
      }
    }
  }
</script>

<style scoped>
  ul {
    padding-left: 0;
  } 
  
  .page-title {
    background-color: rgb(33,33,33);
    color: #FFF;
    padding: 2vh 20vw;
  }
  
  .area-poder {
    display : flex;
    justify-content : center;
    align-items : center;
    background-color:white;
  }

  .area-texto {
    position : center;
    top : 30%; left : 25%;
    min-height:12em;
    color:black;
    text-align:center;
  }

    .area-texto li {
      list-style:none;
    }

  .viewbox {
      fill:"#7c7c7c";
      stroke:"#ffffff";
      stroke-linecap:"round";
      stroke-linejoin:"round";
      stroke-width:"2";
      height:"100%";
      width:"100%";
  }
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/Funciones/PartidosJudiciales/PartidosJudiciales.vue